<template>
  <div>
    <h2 class="section-title">Confiança para você focar no cuidado</h2>
    <p class="section-subtitle">
      Seu time precisa operar com estabilidade. O EasySaúde foi pensado para manter o fluxo consistente e a operação
      sob controle.
    </p>

    <div class="trust">
      <div class="trust-item card">
        <div class="t-icon" aria-hidden="true">🏥</div>
        <div class="t-title">Sistema especializado</div>
        <div class="t-text">
          Rotinas e organização voltadas para o contexto de clínicas multidisciplinares, com foco em neurodesenvolvimento.
        </div>
      </div>
      <div class="trust-item card">
        <div class="t-icon" aria-hidden="true">🔒</div>
        <div class="t-title">Segurança e previsibilidade</div>
        <div class="t-text">Dados organizados e fluxos consistentes para reduzir incerteza no dia a dia.</div>
      </div>
      <div class="trust-item card">
        <div class="t-icon" aria-hidden="true">🧩</div>
        <div class="t-title">Estabilidade na operação</div>
        <div class="t-text">
          Estrutura para acompanhar a demanda com um fluxo que evita “quebras” durante atendimentos.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default { name: 'TrustSection' }
</script>

<style scoped>
.trust {
  margin-top: 22px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 14px;
}

.t-icon {
  width: 46px;
  height: 46px;
  border-radius: 16px;
  background: rgba(77, 186, 135, 0.12);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
}

.t-title {
  margin-top: 12px;
  font-weight: 950;
}

.t-text {
  margin-top: 6px;
  color: var(--easy-muted);
  line-height: 1.6;
  font-size: 14px;
}

@media (max-width: 980px) {
  .trust {
    grid-template-columns: 1fr;
  }
}
</style>
